var React = require('react');

function Plunker (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.221 1.05H3.779c-.724 0-1.418.288-1.929.8a2.725 2.725 0 0 0-.8 1.929l.1.1-.1-.1v12.498a2.727 2.727 0 0 0 2.729 2.729h12.442a2.73 2.73 0 0 0 2.729-2.729V3.779l-.1.1.1-.1c0-.724-.288-1.418-.8-1.929a2.725 2.725 0 0 0-1.929-.8ZM17.3 3.779v12.498a1.078 1.078 0 0 1-1.079 1.079H3.779A1.082 1.082 0 0 1 2.7 16.277V3.779A1.08 1.08 0 0 1 3.779 2.7h12.442A1.08 1.08 0 0 1 17.3 3.779ZM5.512 11.216V8.13l3.367 3.366V5h2.244v6.496L14.49 8.13v3.086l-4.489 4.77-4.489-4.77ZM1.15 3.878l-.052-.06c-.024-.027-.048-.051-.048-.039l.1.099Z","style":{"fillRule":"nonzero"}}));
}

Plunker.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 20 20"};

module.exports = Plunker;

Plunker.default = Plunker;
